import React from 'react'
import { useTranslation } from 'react-i18next'
import { baseUrl } from '@fs/zion-config'
import { useFeatureFlag } from '@fs/zion-flags'
import { css } from '@linaria/core'
import { Link } from '@fs/zion-router'
import { i18n } from '@fs/zion-locale'
import PropTypes from 'prop-types'

const accessibilityLinkCss = css`
  margin-bottom: 8px;
`

export default function AccessibilityLink({ external }) {
  const [t] = useTranslation()
  const accessibilityLinkOn = useFeatureFlag('home_footer_accessibilityLink').isOn

  if (!accessibilityLinkOn) {
    return null
  }

  // TODO: we should not be hand crafting a url with a language like this.
  return (
    <div className={accessibilityLinkCss}>
      <Link
        isGray
        external
        wayfinding
        to={`${external ? baseUrl : ''}/${i18n.language}/about/accessibility-statement`}
        linkName="accessibility_statement"
      >
        {t('footer.accessibility-support', 'Accessibility Support')}
      </Link>
    </div>
  )
}

AccessibilityLink.propTypes = {
  external: PropTypes.bool,
}
